import { useState, createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import { getQrCodeCustomerService } from "../../../services/customerServices";
import { decodeJWT, secondsCountDown } from "../../../utils";

export const qrCodeCustomerContext = createContext({
  qrCode: {},
  setQrCode: () => {},
  handleGetQrCode: () => {},
});

const QrCodeCustomerContext = ({ children }) => {
  const dispatch = useDispatch();

  const [qrCode, setQrCode] = useState({});

  // Get Qr Code
  const handleGetQrCode = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getQrCodeCustomerService();
      if (status === 200) {
        const token = data.result;
        setQrCode(token);
        const time = Math.floor(decodeJWT(token)?.exp - Date.now() / 1000);
        if (time > 0) secondsCountDown("otpCountdown", time, handleGetQrCode);
        else handleGetQrCode();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <qrCodeCustomerContext.Provider
      value={{
        qrCode,
        setQrCode,
        handleGetQrCode,
      }}
    >
      {children}
    </qrCodeCustomerContext.Provider>
  );
};

export default QrCodeCustomerContext;
